import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnnonceCard from './AnnonceCard';
import {RiCalendarEventFill} from 'react-icons/ri'
import { setShowAnnonceModal, setShowAuthModal } from '../../redux/reducers/navigation';

const AnnocesList = () => {
    const dispatch = useDispatch()

    const listAnnonces = useSelector(state => state.annonces.listAnnonces)
    const currentUser = useSelector(state => state.users.currentUser)

    const addAnnonce = ()=>{
        if(currentUser.telephone.length){
            dispatch(setShowAnnonceModal(true))
        }else{
            dispatch(setShowAuthModal(true))
        }
    }

    return (
        <div className='row m-0 p-0'>
            <div className=" d-flex m-0 p-0 justify-content-center align-items-center px-3 mt-3 mb-1">
                <div className="icon-container">
                    <RiCalendarEventFill color='white' size={34}/>
                </div>
                <button className='primary-btn' onClick={addAnnonce}>Ajouter une annonce</button>
            </div>
            <div className="row m-0 p-0 justify-content-center">
                {
                    listAnnonces.filter(item => !item.isArchived).map(item => <AnnonceCard annonce={item}/>)
                }
            </div>
        </div>
    );
};

export default AnnocesList;